import React, { Component } from 'react';
import {ref} from '../config/firebase';
import Nav from './components/Nav';
import Footer from './components/Footer';
import {Tabs, Tab} from 'react-bootstrap';
import firebase from 'firebase';
import FileUploader from 'react-firebase-file-uploader';

import Error from '../helpers/Error';

export default class About extends Component {
	constructor(props) {
		super(props);
		this.state = {
			aKey: 1,
			items: [],
			err: null,
			status: null,
			isUploading: false,
			progress: 0,
			fileUrl : '',
			cvIsUploading: false,
			cvProgress: 0,
			cvUrl: ''
		};
		this.dbItems = ref.child('about');
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleSelect = this.handleSelect.bind(this);
	}

	componentDidMount() {
		this.dbItems.on('value', dataSnapshot => {
			var items = [];

			items = dataSnapshot.val();

			// basic information
			this.description.value = items.description;
			// personal information
			this.name.value = items.name;
			this.email.value = items.email;
			this.phone.value = items.phone;
			this.address.value = items.address;
			this.religion.value = items.religion;
			// social media
			this.wa.value = items.wa;
			this.line.value = items.line;
			this.fb.value = items.fb;
			this.ig.value = items.ig;
			this.linkedin.value = items.linkedin;

			this.setState({items: items});

		});
		
	}

	componentWillUnmount() {
		this.dbItems.off();
	}

	handleSubmit(e) {
		e.preventDefault();

		if( this.name.value !== "" &&
			this.email.value !== "" &&
			this.phone.value !== "" &&
			this.address.value !== "" &&
			this.religion.value !== "" &&
			this.wa.value !== "" &&
			this.line.value !== "" &&
			this.fb.value !== "" &&
			this.ig.value !== "" &&
			this.linkedin.value !== "" &&
			this.description.value !== "") {

			this.dbItems.update({
				//basic information
				description: this.description.value,
				// personal information
				name: this.name.value,
				email: this.email.value,
				phone: this.phone.value,
				address: this.address.value,
				religion: this.religion.value,
				// social media
				wa: this.wa.value,
				line: this.line.value,
				fb: this.fb.value,
				ig: this.ig.value,
				linkedin: this.linkedin.value
			});
			this.setState({
				err: "Success Edit Experience!",
				status: null
			});
			this.handleSelect(1);
			
		}
		else {
			this.setState({err: "Something Wrong", status:'err'});
		}

	}

	handleSelect(aKey) { this.setState({aKey}); }

	handleUploadStart = () => this.setState({ isUploading: true, progress: 0 });
	handleUploadStartCV = () => this.setState({cvIsUploading: true, cvProgress: 0});

	handleProgress = (progress) => this.setState({progress});

	handleUploadError = (error) => {
		this.state({isUploading: false});
		console.log(error);
	}

	handleUploadErrorCV = (error) => {
		this.state({cvIsUploading: false});
		console.log(error);
	}

	handleUploadSuccess = (filename) => {
		this.setState({
			progress: 100,
			isUploading: false
		});

		firebase.storage().ref('basic_info').child(filename)
			.getDownloadURL()
			.then(photoUrl => {
				this.dbItems.update({
					//basic information
					photo: photoUrl
				});

				this.setState({fileUrl: photoUrl});
			});
	}

	handleUploadSuccessCV = (filename) => {
		this.setState({
			cvProgress: 100,
			cvIsUploading: false
		});

		firebase.storage().ref('basic_info').child(filename)
			.getDownloadURL()
			.then(cvUrl => {
				this.dbItems.update({
					//basic information
					cv: cvUrl
				});

				this.setState({cvUrl: cvUrl});
			});
	}



  render () {
  	var dat = [ 'About Me', 'Edit About Me' ];

	  var imgStyle = {
	  	'width' : '100px'
	  };

    return (
    	<div>
    		<Nav />
    		<div className="container">
    			<div className="row">
    				<h1>ABOUT ME</h1>
    				<Error err={this.state.err} status={this.state.status}/>
    				<Tabs activeKey={this.state.aKey} onSelect={this.handleSelect} id="expTab">
    					<Tab eventKey={1} title={dat[0]}>
							<h3>{dat[0]}</h3>
							<div className="panel panel-warning">
								<div className="panel-heading">Basic Information</div>
								<div className="panel-body">
									<table>
										<tbody>
											<tr>
												<td>Photo</td><td>&nbsp;:&nbsp;</td>
												<td><img src={this.state.items.photo} style={imgStyle} alt="andri"/></td>
											</tr>
											<tr>
												<td>CV</td><td>&nbsp;:&nbsp;</td>
												<td><a href={this.state.items.cv} target="_blank" rel="noopener noreferrer">My CV</a></td>
											</tr>
											<tr>
												<td>Description</td><td>&nbsp;:&nbsp;</td>
												<td>{this.state.items.description}</td>
											</tr>
										</tbody>

									</table>
								</div>
							</div>
							<div className="col-md-6">
								<div className="panel panel-info">
									<div className="panel-heading">Personal Information</div>
									<div className="panel-body">
										<table>
											<tbody>
												<tr>
													<td>Name</td><td>&nbsp;:&nbsp;</td>
													<td>{this.state.items.name}</td>
												</tr>
												<tr>
													<td>Phone</td><td>&nbsp;:&nbsp;</td>
													<td>{this.state.items.phone}</td>
												</tr>
												<tr>
													<td>Email</td><td>&nbsp;:&nbsp;</td>
													<td>{this.state.items.email}</td>
												</tr>
												<tr>
													<td>Religion</td><td>&nbsp;:&nbsp;</td>
													<td>{this.state.items.religion}</td>
												</tr>
												<tr>
													<td>Address</td><td>&nbsp;:&nbsp;</td>
													<td>{this.state.items.address}</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>

							<div className="col-md-6">
								<div className="panel panel-info">
									<div className="panel-heading">Social Media</div>
									<div className="panel-body">
										<table>
											<tbody>
												<tr>
													<td>WhatsApp</td><td>&nbsp;:&nbsp;</td>
													<td>{this.state.items.wa}</td>
												</tr>
												<tr>
													<td>Line</td><td>&nbsp;:&nbsp;</td>
													<td>{this.state.items.line}</td>
												</tr>
												<tr>
													<td>Github</td><td>&nbsp;:&nbsp;</td>
													<td><a href={this.state.items.ig} target="_blank" rel="noopener noreferrer">{this.state.items.ig}</a></td>
												</tr>
												<tr>
													<td>Facebook</td><td>&nbsp;:&nbsp;</td>
													<td><a href={this.state.items.fb} target="_blank" rel="noopener noreferrer">{this.state.items.fb}</a></td>
												</tr>
												<tr>
													<td>LinkedIn</td><td>&nbsp;:&nbsp;</td>
													<td><a href={this.state.items.linkedin} target="_blank" rel="noopener noreferrer">{this.state.items.linkedin}</a></td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
    					</Tab>
    					
    					<Tab eventKey={2} title={dat[1]}>
							<h3>{dat[1]}</h3>
						    <form onSubmit={this.handleSubmit}>
								<div>
									<h4><i>Basic Information</i></h4>
									<div className="form-group">
										<label>Photo</label>
										{
											this.state.isUploading &&
											<p>Progress: {this.state.progress}</p>
										}
										{
											this.state.fileUrl &&
											<img src={this.state.fileUrl} width="150px" alt="file"/>
										}
										<FileUploader
											accept="*"
											name="photo"
											randomizeFilename
											storageRef={firebase.storage().ref('basic_info')}
											onUploadStart={this.handleUploadStart}
											onUploadError={this.handleUploadError}
											onUploadSuccess={this.handleUploadSuccess}
											onProgress={this.handleProgress}
										/>
									</div>
									<div className="form-group">
										<label>CV</label>
										{
											this.state.cvIsUploading &&
											<p>Progress: {this.state.cvProgress}</p>
										}
										{
											this.state.cvUrl &&
											<a href={this.state.cvUrl} target="_blank" rel="noopener noreferrer">&nbsp;-&nbsp;Click Here</a>
										}
										<FileUploader
											accept="*"
											name="cv"
											randomizeFilename
											storageRef={firebase.storage().ref('basic_info')}
											onUploadStart={this.handleUploadStartCV}
											onUploadError={this.handleUploadErrorCV}
											onUploadSuccess={this.handleUploadSuccessCV}
											onProgress={this.handleProgress}
										/>
									</div>
									<div className="form-group">
										<label>Description</label>
										<textarea ref={(description) => this.description = description} className="form-control"></textarea>
									</div>
								</div>

								<div className="col-md-12">
									<div className="col-md-6">
										<h4><i>Personal Information</i></h4>
										<div className="form-group">
											<label>Name</label>
											<input type="text" ref={(name) => this.name = name} className="form-control"/>
										</div>
										<div className="form-group">
											<label>Email</label>
											<input type="text" ref={(email) => this.email = email} className="form-control"/>
										</div>
										<div className="form-group">
											<label>Phone</label>
											<input type="text" ref={(phone) => this.phone = phone} className="form-control"/>
										</div>
										<div className="form-group">
											<label>Religion</label>
											<input type="text" ref={(religion) => this.religion = religion} className="form-control"/>
										</div>
										<div className="form-group">
											<label>Address</label>
											<textarea ref={(address) => this.address = address} className="form-control"></textarea>
										</div>
									</div>

									<div className="col-md-6">
										<h4><i>Social Media</i></h4>
										<div className="form-group">
											<label>WhatsApp</label>
											<input type="text" ref={(wa) => this.wa = wa} className="form-control"/>
										</div>

										<div className="form-group">
											<label>Line</label>
											<input type="text" ref={(line) => this.line = line} className="form-control"/>
										</div>

										<div className="form-group">
											<label>Instagram</label>
											<input type="text" ref={(ig) => this.ig = ig} className="form-control"/>
										</div>

										<div className="form-group">
											<label>Facebook</label>
											<input type="text" ref={(fb) => this.fb = fb} className="form-control"/>
										</div>

										<div className="form-group">
											<label>LinkedIn</label>
											<input type="text" ref={(linkedin) => this.linkedin = linkedin} className="form-control"/>
										</div>
									</div>
								</div>

								<div>
									<button type="submit" className="btn btn-default">Edit</button> &nbsp;
									<button type="reset" className="btn btn-warning">Cancel</button>
								</div>
							</form>
    					</Tab>
    				</Tabs>
		    		
				</div>
			</div>
			<Footer/>
    	</div>
      
    )
  }
}


// WEBPACK FOOTER //
// ./src/auth_pages/About.js